export const validateCustomPrintPhotoSelections = config => {
  if (!config) {
    return false;
  }

  const { photos } = config;

  if (photos.some(({ photo }) => !photo?.id)) {
    return false;
  }

  return true;
};
